"use client";
import PropertyCarousel2 from "../components/PropertyCarousel2";
import { PropertyUtilities3 } from "../../../constants/utilitiesIcons";
import { AccordionVariant } from "./Sale3";
import { SideItem3 } from "./Sale3";
import { camelCaseToWords, ParentCard } from "../../design1/PropertyPage1";
import { generateSliderImages } from "../components/PropertyCarousel2";
import { KeyValueDisplay } from "./Sale3";
import { mockProperties } from "../../../constants/mockProperties";
import React from "react";
import Example from "../../design1/components/Map";
import dayjs from "dayjs";
import { getCurrencySign } from "src/app/lib/getCurrencySign";
import utc from "dayjs/plugin/utc";
import { useParams } from "next/navigation";
import relativeTime from "dayjs/plugin/relativeTime";
import { Advanced } from "../../design2/Rent2";
import StyledWraper from "../components/StyledWraper";
import { ShowMoreText } from "../../design1/About1";
import { Currency, PropertyType } from "src/types";
import useCompanyListingDetails from "src/app/lib/useFecthCompanyListing";
import PropertyPageSkeleton from "../../design1/components/skeletons/PropertyPage";
import { AddressIcon } from "../../design1/components/Listing";
import { AddressLink } from "../../design2/ContactUs2";
import PropertyCardSkeleton from "../../design2/components/Skeletons/PropertyCard";
import {
  extractIdFromSlug,
  formatPropertyInfo,
  formatTenantFields,
  newTenantsFields,
  PropertyFaq,
  renewalTenantsFields,
} from "src/app/serverUtils";
dayjs.extend(relativeTime);
dayjs.extend(utc);
const Rent3 = () => {
  const search = useParams();
  const { id } = search;
  const newId = extractIdFromSlug(id as string);
  const isDemo = process.env.NEXT_PUBLIC_DEMO_MODE === "true";
  const {
    data: item,
    isError,
    isLoading,
  } = useCompanyListingDetails(newId) as {
    data: PropertyType | undefined;
    isError: boolean;
    isLoading: boolean;
  };
  if (isLoading && !isDemo) {
    return <PropertyPageSkeleton />;
  }
  if (isError && !isDemo) {
    return <div>Error occurred</div>;
  }
  const property = isDemo ? mockProperties.forRent[0] : item;
  if (!property && !isDemo) {
    return <div>Not available</div>;
  }
  if (!property) {
    return <div>Data not available</div>;
  }
  const currency = getCurrencySign(property.currency);
  const newTenantsData = formatTenantFields(
    property,
    currency as unknown as Currency,
    newTenantsFields
  );
  const renewalTenantsData = formatTenantFields(
    property,
    currency as unknown as Currency,
    renewalTenantsFields
  );
  const isOutRight = !property.beforePrice;
  const images = generateSliderImages(property.images);
  const info = formatPropertyInfo(property);
  return (
    <section>
      <div className="pb-10 pt-5">
        <PropertyCarousel2
          images={[
            ...images,
            ...(property.videoLink
              ? [
                  {
                    url: property.videoLink,
                    type: "video" as const,
                  },
                ]
              : []),
          ]}
        />
        <div className="wrapper">
          <PropertyCard3
            type={property.type}
            category={property.category}
            quote={property.quote}
            variant
            title={property.title}
            price={property.price}
            propertyId={`${property.propertyId!}`}
            address={property.address}
            beforePrice={property?.beforePrice}
            discount={property.discount}
            quotePrice={property.quotePrice}
            priceType={property.priceType}
          />
          <div className="grid-container relative mt-12">
            <div className="first flex flex-col gap-4">
              {" "}
              <StyledWraper>
                <ParentCard header="Property Brief">
                  <ShowMoreText
                    text={property.propertyDesc || "No description available"}
                  />
                </ParentCard>
              </StyledWraper>
              <StyledWraper>
                {property.facilities && property.facilities.length > 0 && (
                  <ParentCard header="Facilities">
                    <PropertyUtilities3 selectedItems={property.facilities} />
                  </ParentCard>
                )}
              </StyledWraper>
              <StyledWraper>
                <ParentCard header="Property Information">
                  <KeyValueDisplay data={info} />
                </ParentCard>
              </StyledWraper>
              {!isOutRight && (
                <StyledWraper>
                  <AccordionVariant data={PropertyFaq} />
                </StyledWraper>
              )}
              <StyledWraper>
                <ParentCard header="New Tenants">
                  <KeyValueDisplay data={newTenantsData} />
                </ParentCard>
              </StyledWraper>
              <StyledWraper>
                <ParentCard header="Renewal Tenants">
                  <KeyValueDisplay data={renewalTenantsData} />
                </ParentCard>
              </StyledWraper>
              {property.coordinate && (
                <StyledWraper>
                  <ParentCard header="Location">
                    <Example coordinates={property.coordinate} />
                  </ParentCard>
                </StyledWraper>
              )}
            </div>

            <SideItem3
              properties={property.staffListing}
              members={property.staff!}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
export default Rent3;

export const PropertyCard3: React.FC<Advanced> = ({
  title,
  price,
  propertyId,
  type,
  quote,
  address,
  beforePrice,
  discount,
  category,
  quotePrice,
  loading,
  priceType,
  className,
  variant,
}) => {
  if (loading) {
    return <PropertyCardSkeleton loading={loading} />;
  }
  return (
    <div
      className={`items ${
        variant && "grid-container !grid"
      } mt-6 mb-4 flex xs:flex-col xs:gap-3 xs:items-start items-center justify-between ${
        className || ""
      }`}
    >
      {/* Left Section */}
      <div className={`${variant && "flex justify-between"}`}>
        <div className={`first flex flex-col !gap-2`}>
          <span className="flex items-center justify-between">
            {propertyId && (
              <div className={`if text-label-main text-xl`}>
                (Property ID: {propertyId})
              </div>
            )}
            <h6 className="p-2 hidden sm:block text-sm px-2 rounded-md h-max capitalize  bg-themeColor text-white ">
              {category}
            </h6>
          </span>

          <h1 className={"font-semibold"}>{title}</h1>
          {address && (
            <div
              className={`addy ${
                variant && "text-[1.5rem]"
              } items-center gap-3 flex`}
            >
              <div className="address flex gap-3">
                <span className="block">
                  <AddressIcon
                    color={variant ? "#606060" : ""}
                    className="!h-[25px] !w-[25px]"
                  />
                </span>

                <AddressLink
                  className="text-label-main capitalize"
                  address={address}
                />
              </div>
            </div>
          )}
        </div>

        <h6 className="p-2 h-max px-3 sm:hidden capitalize text-xl bg-themeColor text-white rounded-xl">
          {category}
        </h6>
      </div>

      {/* Right Section - Pricing */}
      <div className="price flex flex-col xs:items-start  items-end">
        <div className="item  items-end  gap-1 flex">
          {discount && <span className={`text-secondary-main block`}>Now</span>}
          <h2
            className={`text-themeColor h2 !font-normal ${
              !variant && !discount && "5xl"
            }  leading-none w-max text-right`}
          >
            {beforePrice && (
              <span
                className={`text-secondary-main text-base block text-left line-through ${
                  variant && "text-right"
                }`}
              >
                Before: ₦{beforePrice.toLocaleString()}
              </span>
            )}
            ₦{price.toLocaleString()}
            {type && type === "rent" && (
              <div className=" text-xl text-secondary-main">
                {camelCaseToWords(priceType!)}
              </div>
            )}
          </h2>
          {discount && <span className={`text-secondary-main block`}>Now</span>}
        </div>

        {/* Other Pricing Info */}
        <div
          className={`other  flex gap-3 ${
            variant && discount && "text-[1.2rem]"
          }  ${variant && !discount && "text-[2rem]"}`}
        >
          {quotePrice && priceType && (
            <span className="text-secondary-main">
              <span className="text-themeColor">
                ₦{quotePrice.toLocaleString()}
              </span>{" "}
              / {camelCaseToWords(quote)}
            </span>
          )}
          {discount && (
            <span className="text-themeColor">
              {discount} Discount on Initial Price
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
